import React, { createContext, Dispatch, useReducer } from "react";
import { Divisions } from "../../types/Divisions";
import { DivisionActions, divisionReducer } from "./Reducers";

type InitialStateType = {
   Divisions: Divisions[];
};

const initialState = {
   Divisions: [],
};

const DivisionContext = createContext<{
   state: InitialStateType;
   dispatch: Dispatch<DivisionActions>;
}>({
   state: initialState,
   dispatch: () => null,
});

const mainReducer = ({ Divisions }: InitialStateType, action: DivisionActions) => ({
   Divisions: divisionReducer(Divisions, action),
});

// eslint-disable-next-line react/prop-types
const DivisionProvider: React.FC = ({ children }) => {
   const [state, dispatch] = useReducer(mainReducer, initialState);
   return <DivisionContext.Provider value={{ state, dispatch }}>{children}</DivisionContext.Provider>;
};

export { DivisionProvider, DivisionContext };
//BUG IN prettier.
